import { useMutation } from 'react-query';

// Our Axios Instance
import axiosInstance from 'services/API/API';

// Our Endpoint urls
import { maskAsAnotherUserEndpoint } from 'shared/api-urls';

function useMutateUnmask() {
	return useMutation(
		async () => {
			const response = await axiosInstance.post(
				maskAsAnotherUserEndpoint,
				{
					unmasq: true
				}
			);

			const responseData = response.data;

			return responseData;
		},
		{
			onError: (error) => {
				console.error('Error when trying to mask account', error);
			}
		}
	);
}

export default useMutateUnmask;
